"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

require("../listeners/focusStylesListener");

var _setupStyledComponents = require("../listeners/setupStyledComponents");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Functions = require("../core/Functions");

var _ShareButton = _interopRequireDefault(require("../decorators/ShareButton"));

var _refObject = _interopRequireDefault(require("../utils/propTypes/refObject"));

var _TabIndex = require("../utils/TabIndex");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  cursor: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

(0, _setupStyledComponents.setupStyledComponents)();

var UIClickableCore =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(UIClickableCore, _React$Component);

  function UIClickableCore() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, UIClickableCore);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(UIClickableCore)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleKeyDown = function (evt) {
      var key = evt.key,
          target = evt.target;
      var _this$props = _this.props,
          buttonRef = _this$props.buttonRef,
          disabled = _this$props.disabled,
          onClick = _this$props.onClick,
          onKeyDown = _this$props.onKeyDown;
      (0, _Functions.callIfPossible)(onKeyDown, evt);
      if (target !== buttonRef.current) return; // Simulate click on Enter/Spacebar, to emulate button behavior

      if (key === 'Enter' || key === ' ') {
        if (disabled) {
          evt.preventDefault();
          evt.stopPropagation();
          return;
        }

        (0, _Functions.callIfPossible)(onClick, evt);

        if (key === ' ') {
          evt.preventDefault(); // Prevent page from scrolling (#3575)
        }
      }
    };

    _this.handleClick = function (evt) {
      var _this$props2 = _this.props,
          disabled = _this$props2.disabled,
          onClick = _this$props2.onClick;

      if (disabled) {
        evt.preventDefault();
        evt.stopPropagation();
        return;
      }

      (0, _Functions.callIfPossible)(onClick, evt);
    };

    return _this;
  }

  (0, _createClass2.default)(UIClickableCore, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props3 = this.props,
          autoFocus = _this$props3.autoFocus,
          buttonRef = _this$props3.buttonRef;

      if (autoFocus) {
        if (buttonRef.current) buttonRef.current.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          buttonRef = _this$props4.buttonRef,
          className = _this$props4.className,
          __cursor = _this$props4.cursor,
          disabled = _this$props4.disabled,
          __onClick = _this$props4.onClick,
          __onKeyDown = _this$props4.onKeyDown,
          tabIndex = _this$props4.tabIndex,
          Tag = _this$props4.tagName,
          rest = (0, _objectWithoutProperties2.default)(_this$props4, ["buttonRef", "className", "cursor", "disabled", "onClick", "onKeyDown", "tabIndex", "tagName"]);
      return _react.default.createElement(Tag, (0, _extends2.default)({}, rest, {
        "aria-disabled": disabled,
        className: (0, _classnames.default)('private-clickable', className),
        onClick: this.handleClick,
        onKeyDown: this.handleKeyDown,
        ref: buttonRef,
        tabIndex: (0, _TabIndex.getTabIndex)(disabled, tabIndex, null)
      }));
    }
  }]);
  return UIClickableCore;
}(_react.default.Component);

UIClickableCore.displayName = 'UIClickable';
var UIClickable = (0, _styledComponents.default)(UIClickableCore).withConfig({
  displayName: "UIClickable",
  componentId: "sc-1tpe8u1-0"
})(_templateObject(), function (_ref) {
  var cursor = _ref.cursor,
      disabled = _ref.disabled;
  return disabled ? 'not-allowed' : cursor;
});
UIClickable.propTypes = {
  autoFocus: _propTypes.default.bool,
  buttonRef: _refObject.default,
  cursor: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  tagName: _propTypes.default.string.isRequired
};
UIClickable.defaultProps = {
  cursor: 'pointer',
  role: 'button',
  tagName: 'div'
}; // Expose the inner component for tests

UIClickable.CoreComponent = UIClickableCore;
UIClickable.WrappedComponent = UIClickableCore;
UIClickable.displayName = 'Styled(UIClickable)';

var _default = (0, _ShareButton.default)(UIClickable);

exports.default = _default;
module.exports = exports.default;